import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    CardTypeService,
    CardTypePopupService,
    CardTypeComponent,
    CardTypeDetailComponent,
    CardTypeDialogComponent,
    CardTypePopupComponent,
    CardTypeDeletePopupComponent,
    CardTypeDeleteDialogComponent,
    cardTypeRoute,
    cardTypePopupRoute,
} from './';

let ENTITY_STATES = [
    ...cardTypeRoute,
    ...cardTypePopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        CardTypeComponent,
        CardTypeDetailComponent,
        CardTypeDialogComponent,
        CardTypeDeleteDialogComponent,
        CardTypePopupComponent,
        CardTypeDeletePopupComponent,
    ],
    entryComponents: [
        CardTypeComponent,
        CardTypeDialogComponent,
        CardTypePopupComponent,
        CardTypeDeleteDialogComponent,
        CardTypeDeletePopupComponent,
    ],
    providers: [
        CardTypeService,
        CardTypePopupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiCardTypeModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/card-type/card-type.module.ts